<template functional>
    <b-button
        v-bind="data.attrs"
        :class="[data.staticClass, data.class, {
            'hemocir-button-secondary': props.variant === 'secondary',
            'hemocir-button-outline-gray': props.variant === 'outline-gray',
            'btn-secondary': props.variant === 'secondary-bootstrap',
        }]"
        :variant="props.variant.includes('outline') ? 'outline-primary' : (props.variant === 'secondary-bootstrap' ? 'secondary' : 'primary')"
        v-on="listeners"
    >
        <slot>
            <i v-if="props.fontAwesomeIcon && !props.rightIcon" class="fas mr-2" :class="props.fontAwesomeIcon"></i>
            {{ props.title }}
            <i v-if="props.fontAwesomeIcon && props.rightIcon" class="fas ml-2" :class="props.fontAwesomeIcon"></i>
        </slot>
    </b-button>
</template>

<script>
    /**
     * Examples of usage
     *
     * <hemocir-button
     *    title="foo"
     * />
     * <hemocir-button
     *    title="foo"
     *    variant="outline-gray"
     * />
     * <hemocir-button
     *    title="foo"
     *    font-awesome-icon="fa-user-plus"
     *    variant="secondary"
     * />
     * <hemocir-button
     *    title="foo"
     *    font-awesome-icon="fa-plus-circle"
     *    variant="outline-gray"
     * />
     * <hemocir-button
     *    title="foo"
     *    font-awesome-icon="fa-angle-right"
     *    variant="outline-primary"
     *    right-icon
     * />
     */
    export default {
        name: "HemocirButton",
        props: {
            title: {
                type: String,
            },
            fontAwesomeIcon: {
                type: String,
                default: '',
            },
            variant: {
                type: String,
                default: 'primary',
                validator: value => [
                    'primary',
                    'secondary',
                    'secondary-bootstrap',
                    'outline-primary',
                    'outline-gray'
                ].indexOf(value) !== -1,
            },
            rightIcon: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>

</style>